/**
 * 料金表示がない場合、slackに通知送る処理
 */

import React, { FC, useState } from 'react';
import { useRecreationPrice } from './hooks';
import { PriceModal } from './components/priceModal';
import { LoadingIndicator } from '../shared';

export const FacilityConsultPrice: FC<{
  recreationId: number;
}> = ({ recreationId }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { isSending, consultRecreationPrice } = useRecreationPrice();

  const onClick = async (): Promise<void> => {
    try {
      await consultRecreationPrice(recreationId);
      setIsOpen(true);
    } catch (e) {
      console.error(e);
      throw e;
    }
  };

  const handleClose = (): void => setIsOpen(false);

  return (
    <>
      {isSending ? (
        <div className='container'>
          <div className='d-flex justify-content-center'>
            <LoadingIndicator />
          </div>
        </div>
      ) : (
        <button
          type='button'
          role='button'
          className='btn-cpr'
          onClick={onClick}
        >
          相談・依頼する
        </button>
      )}

      <PriceModal isOpen={isOpen} onClose={handleClose} />
    </>
  );
};
